import { onAuthStateChanged } from 'firebase/auth';
import axios from 'utils/axios';
import { auth } from '../../../firebase';
import { v4 as uuidv4 } from 'uuid';

const getBotsByPromptId = (promptId, callback) => {
  return async (dispatch) => {
    dispatch({ type: 'FETCHING_BOTS_BY_PROMPT_ID' });
    try {
      let unsubscribe = onAuthStateChanged(auth, async (user) => {
        const token = await user?.getIdToken();
        const reqId = uuidv4();
        try {
          const response = await axios.get(`/ads/prompts/${promptId}/bots`, {
            params: {
              'request-id': reqId,
            },
            headers: {
              Authorization: `Bearer ${token}`,
              // 'x-api-version': 'v2',
            },
          });
          if (response.status === 200) {
            await dispatch({
              type: 'FETCHING_BOTS_BY_PROMPT_ID_DONE',
              payload: {
                bots: response?.data,
              },
            });
            if (typeof callback === 'function') {
              callback(response?.data);
            }
          } else {
            dispatch({
              type: 'FETCHING_BOTS_BY_PROMPT_ID_FAILED',
              payload: `Failed to get bots by prompt id`,
            });
          }
        } catch (e) {
          dispatch({
            type: 'FETCHING_BOTS_BY_PROMPT_ID_FAILED',
            payload: `Failed to get bots by prompt id`,
          });
        }
        unsubscribe();
      });
    } catch (e) {
      dispatch({
        type: 'FETCHING_BOTS_BY_PROMPT_ID_FAILED',
        payload: `Failed to get bots by prompt id`,
      });
    }
  };
};

export default getBotsByPromptId;
